(() => {
  const avatar = document.currentScript?.dataset.authorAvatar;
  const profile = 'https://www.instagram.com/maksttonwheel_yang/';
  if (!avatar) return;
  function update() {
    if (!document.body.classList.contains('mw-guides-page')) return;
    document.querySelectorAll('#MainContent article, #MainContent .mw-wheel-measurement').forEach(article => {
      // Some older guides use plain paragraphs instead of a credits container.
      article.querySelectorAll('p').forEach(p => {
        if (!p.textContent.includes('Binghua Yang') || !p.textContent.includes('Product Development Manager') || p.closest('[class*="credits"], [aria-label="Article credits"], .mw-unified-author')) return;
        const credits = document.createElement('div'); credits.setAttribute('aria-label', 'Article credits');
        const next = p.nextElementSibling;
        p.before(credits); credits.append(p);
        if (next?.matches('p') && /^Technical data:/i.test(next.textContent.trim())) credits.append(next);
      });
      const candidates = article.querySelectorAll('[class*="credits"], [aria-label="Article credits"]');
      candidates.forEach(credits => {
        if (credits.classList.contains('mw-unified-author') || !credits.textContent.includes('Binghua Yang')) return;
        // Keep an existing author card intact; normalize its layout only.
        const existingAvatar = credits.querySelector('.mw-author-avatar');
        if (existingAvatar) { credits.classList.add('mw-unified-author'); return; }
        const text = document.createElement('div');
        while (credits.firstChild) text.append(credits.firstChild);
        const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (!node.textContent.includes('Binghua Yang')) continue;
          const oldLink = node.parentElement.closest('a');
          if (oldLink) { oldLink.href = profile; oldLink.target = '_blank'; oldLink.rel = 'noopener noreferrer'; break; }
          const at = node.textContent.indexOf('Binghua Yang');
          const name = node.splitText(at); name.splitText('Binghua Yang'.length);
          const link = document.createElement('a'); link.href = profile; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.className = 'mw-author-name';
          name.replaceWith(link); link.append(name); break;
        }
        const link = document.createElement('a');
        link.className = 'mw-author-avatar'; link.href = profile; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.setAttribute('aria-label', 'Binghua Yang on Instagram');
        const img = document.createElement('img'); img.src = avatar; img.alt = 'Binghua Yang'; img.width = 48; img.height = 48; img.loading = 'lazy'; link.append(img);
        credits.append(link, text); credits.classList.add('mw-unified-author');
      });
    });
  }
  update();
  document.addEventListener('shopify:section:load', update);
})();
